import { Inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { format, isValid, Locale, parse, parseISO } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { castArray } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class DateFnsHelpersService {
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) private locale: Locale) {}

  toNeutralDate(value: Date | string): string {
    let date: Date | null;
    if (typeof value === 'string') {
      date = this.parse(value, 'P');
    } else {
      date = value;
    }

    if (!date) {
      return '';
    }

    return format(date, 'yyyy-MM-dd');
  }

  parse(value: unknown, parseFormat: string | string[]): Date | null {
    if (typeof value == 'string' && value.length > 0) {
      const iso8601Date = parseISO(value);

      if (this.isValid(iso8601Date)) {
        return iso8601Date;
      }

      const formats = castArray(parseFormat);

      if (!parseFormat.length) {
        throw Error('Formats array must not be empty.');
      }

      for (const currentFormat of formats) {
        const fromFormat = parse(value, currentFormat, new Date(), {
          locale: this.locale,
        });

        if (this.isValid(fromFormat)) {
          return zonedTimeToUtc(fromFormat, 'utc');
        }
      }

      return this.invalid();
    } else if (typeof value === 'number') {
      return new Date(value);
    } else if (value instanceof Date) {
      return this.clone(value);
    }

    return null;
  }

  clone(date: Date): Date {
    return new Date(date.getTime());
  }

  isValid(date: Date): boolean {
    return isValid(date);
  }

  invalid(): Date {
    return new Date(NaN);
  }
}
